import {currentPath} from 'ladder/browser2'
import {urlToRoute} from 'ladder/router2'

import {jsclj, resolveGoogExport, keyword, hash_map} from 'dgetz/tsclj'

interface TrackedUrlArgs {
    id: string; // keyword-string, no ":"
    url: string;
    route?: string | null; // Nullable as per Clojure's nil? check
    arg?: string;
}

/**
 * route: when null, read from window.location
 * id: cljs.keyword as string, without ":"
 * */
export function trackedUrl({id, url, route, arg}: TrackedUrlArgs): string {
    let tracked_url = resolveGoogExport('ladder.ux.link.tracked_url');
    return tracked_url(
        hash_map(
            keyword("id"), keyword(id),
            keyword("url"), url,
            keyword("route"), route && keyword(route),
            keyword("arg"), arg
        )
    );
}

interface NewLinkProps {
    size?: string;
    onClick?: Function;
    underline?: boolean;
    textAlign?: string;
    className?: string;
    popout?: boolean;
    href?: string;
    color?: string;
    children: any;
}

export function NewLink ({className, size, onClick, children, underline, textAlign, popout, href, color}: NewLinkProps) {
    let new_link = resolveGoogExport('ladder.ux.link.new_link');
    return new_link(jsclj({
        size,
        "class": className,
        "text-align": textAlign && keyword(textAlign),
        'on-click': onClick,
        'underline?': underline,
        'popout?': popout,
        'href': href,
        'color': color,
    }), children);
}
